import { render, staticRenderFns } from "./ColumnShow.vue?vue&type=template&id=35507590&scoped=true"
import script from "./ColumnShow.vue?vue&type=script&lang=js"
export * from "./ColumnShow.vue?vue&type=script&lang=js"
import style0 from "./ColumnShow.vue?vue&type=style&index=0&id=35507590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35507590",
  null
  
)

export default component.exports